import NavBarWrapper from "@Components/NavigationBar/NavBarWrapper";
import NavigationBar from "@Components/NavigationBar/NavigationBar";
import CreateIngredientExit from "@Pages/RegulatoryMember/IngredientExit/CreateIngredientExit";
import FallbackPage from "@Pages/FallBackPage/FallBackPage";
import AdminHome from "@Pages/Admin/AdminHomePage/AdminHomePage";
import Login from "@Pages/Login/Login";
import RegulatoryMemberHome from "../Pages/RegulatoryMember/HomePage/RegulatoryMemberHome";
import ExitRequestDetail from "@Pages/RegulatoryMember/ExitRequestDetail/ExitRequestDetail";
import Notification from "@Pages/Notification/Notification";
import MyPendingExitRequestsListing from "../Pages/RegulatoryMember/PendingExitRequestsFolder/MyPendingExitRequestsListing/MyPendingExitRequestsListing"
import AllPendingExitRequestsListing from "../Pages/RegulatoryMember/PendingExitRequestsFolder/AllPendingExitRequestsListing/AllPendingExitRequestsListing"

// Import R&D Member components
import RnDMemberHome from "@Pages/RnDMember/RnDMemberHome/RnDMemberHome";
import IncomingExitRequestsListing from "@Pages/RnDMember/IncomingExitRequestsListing/IncomingExitRequestsListing";
import ExitRequestResponseUnified from "@Pages/RnDMember/ExitRequestResponseUnified/ExitRequestResponseUnified";
import ExitPlansListing from "@Pages/RnDMember/ExitPlansListing/ExitPlansListing";
import ExitPlanPage from "@Pages/RnDMember/ExitPlanForm/ExitPlanPage/ExitPlanPage";
import ExitPlanDetail from "@Pages/RnDMember/ExitPlanDetail/ExitPlanDetail";
import ExitRequestDetailRD from "@Pages/RnDMember/ExitRequestDetail/ExitRequestDetail";
import { useSelector } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import SideBar from "@Components/SideBar/SideBarComponent";
import { Box } from "@mui/material";
import Profile from "@Pages/Profile/ProfilePage";
import { useTheme } from "@mui/material/styles";
import MyResponsesListing from "../Pages/RnDMember/MyResponsesListing/MyResponsesListing";
import UsersListing from "../Pages/Admin/Users/UsersListing";
import CategoriesListing from "../Pages/Admin/Categories/CategoriesListing";
import RegionsListing from "../Pages/Admin/Regions.js/RegionsListing";
import AllCanceledExitRequestsListing from "../Pages/RegulatoryMember/CanceledExitRequestsFolder/AllCanceledExitRequestsListing/AllCanceledExitRequestsListing";
import MyCanceledExitRequestsListing from "../Pages/RegulatoryMember/CanceledExitRequestsFolder/MyCanceledExitRequestsListing/MyCanceledExitRequestsListing";
import RegulatoryMemberDelegationRequests from "../Pages/RegulatoryMember/DelegationListing/RegulatoryMemberDelegationListing";
import ExtensionRequestsListing from "../Pages/RegulatoryMember/ExtensionRequestsListing/ExtensionRequestsListing";
import ExtensionRequestDetails from "../Pages/ExtensionRequestDetails/ExtensionRequestDetails";
import RnDDelegationRequests from "../Pages/RnDMember/DelegationListing/RnDDelegationListing";
import DelegateRequestDetails from "../Pages/DelegateRequestDetails/DelegateRequestDetails";
import AllPendingExitRequestsListingFromRD from "../Pages/RnDMember/AllPendingExitRequest/AllPendingExitRequest";
import VerificationCode from "@Pages/VerificationCode/VerificationCode";
import EmailVerifyScreen from "@Pages/EmailVerifyScreen/EmailVerifyScreen";
import ChangePasswordScreen from "@Pages/ChangePasswordScreen/ChangePasswordScreen";
import ApproverHome from "../Pages/Approver/ApproverHome";
import {PendingApprovals} from "./DefaultRoutes";
import PendingApprovalsListing from "../Pages/Approver/PendingApprovals";
import AssignedRequestsListing from "../Pages/Approver/AssignedRequests";
import AllExitRequestsListing from "../Pages/Approver/AllExitRequests";
import EscalatedRequestsListing from "../Pages/Approver/EscalatedRequestsListing";
import ExitRequestDetailApprover from "../Pages/Approver/ExitRequestDetailApprover";
// kept for the hidden "Plans to Approve" page
// import PlansPendingApprovalListing from "../Pages/Approver/PlansPendingApproval";

// Exemption Requests
import MyExemptionsListing from "@Pages/Exemptions/ExemptionsHub/MyExemptionsListing";
import RegulatoryExemptionsListing from "@Pages/Exemptions/ExemptionsHub/RegulatoryExemptionsListing";
import ExemptionsPendingApproval from "@Pages/Approver/ExemptionsPendingApproval";
import AllExemptionsListing from "@Pages/Exemptions/ExemptionsHub/AllExemptionsListing";
import ExemptionRequestPage from "@Pages/Exemptions/ExemptionRequestPage/ExemptionRequestPage";

// Import RD-Manager components
import RDManagerHome from "../Pages/RDManager/RDManagerHome/RDManagerHome";
import RDManagerIncomingExitRequestsListing from "../Pages/RDManager/IncomingExitRequestsListing/RDManagerIncomingExitRequestsListing";

// Import Support Provider components
import SupportProviderHome from "../Pages/SupportProvider/SupportProviderHome/SupportProviderHome";
import SupportProviderAssignedRequests from "../Pages/SupportProvider/AssignedRequestsPage/AssignedRequestsPage";
import SupportProviderAllRequests from "../Pages/SupportProvider/AllRequestsPage/AllRequestsPage";
import SupportProviderRequestsHub from "../Pages/SupportProvider/RequestsHubPage/RequestsHubPage";
import SupportRequestDetail from "../Pages/SupportProvider/SupportRequestDetail/SupportRequestDetail";

// Import R&D Coordinator components
import RDCoordinatorHome from "../Pages/RDCoordinator/RDCoordinatorHome/RDCoordinatorHome";
import CoordinatorIncomingRequestsListing from "../Pages/RDCoordinator/IncomingRequests/CoordinatorIncomingRequestsListing";
import CoordinatorResponsePage from "../Pages/RDCoordinator/ResponsePage/CoordinatorResponsePage";
import CoordinatorResponsesListing from "../Pages/RDCoordinator/ResponsesListing/CoordinatorResponsesListing";

export default function Paths() {
  const user = useSelector((state) => state.user);
  const theme = useTheme();
  return (
    <Router>
      <NavBarWrapper user={user}>
        <NavigationBar text="" user={user} />
      </NavBarWrapper>
      {user.isLogged && <SideBar />}

      {user.isLogged && user.role === "REGULATORY" && (
        <Box
          sx={{
            pt: `${theme.navbar.navbarHeight}px`,
            ml: `${theme.sidebar.sidebarWidth}px`,
          }}
        >
          <Routes>
            <Route path="/" element={<RegulatoryMemberHome />} />
            <Route
              path={DefaultRoutes.home}
              element={<RegulatoryMemberHome />}
            />

            {/* Direct access to create new ingredient exit (from home) */}
            <Route
              path={DefaultRoutes.createIngredientExit}
              element={<CreateIngredientExit />}
            />

            {/* Access to create/edit exit request from my active requests
            <Route
              path={DefaultRoutes.createFromMyRequests}
              element={<CreateIngredientExit />}
            /> */}
            <Route
              path={DefaultRoutes.editExitRequest}
              element={<CreateIngredientExit />}
            />

            <Route
              path={DefaultRoutes.error}
              element={<FallbackPage isErrorPage={true} />}
            />
            <Route path={DefaultRoutes.profile} element={<Profile />} />
            <Route
              path={DefaultRoutes.notifications}
              element={<Notification />}
            />

            {/* Active exit requests routes */}
            <Route
              path={DefaultRoutes.activeReqs}
              element={<AllPendingExitRequestsListing />}
            />
            <Route
              path={DefaultRoutes.myActiveReqs}
              element={<MyPendingExitRequestsListing />}
            />
            <Route
              path={DefaultRoutes.reqInfo}
              element={<ExitRequestDetail />}
            />
            <Route
              path={DefaultRoutes.myReqInfo}
              element={<ExitRequestDetail />}
            />

            {/* Canceled exit requests routes */}
            <Route
              path={DefaultRoutes.canceledReqs}
              element={<AllCanceledExitRequestsListing />}
            />
            <Route
              path={DefaultRoutes.myCanceledReqs}
              element={<MyCanceledExitRequestsListing />}
            />
            <Route
              path={DefaultRoutes.canceledReqInfo}
              element={<ExitRequestDetail />}
            />
            <Route
              path={DefaultRoutes.myCanceledReqInfo}
              element={<ExitRequestDetail />}
            />
            <Route
              path={DefaultRoutes.regDelegationRequests}
              element={<RegulatoryMemberDelegationRequests />}
            />
            <Route
              path={DefaultRoutes.regExtensionRequests}
              element={<ExtensionRequestsListing />}
            />
            <Route
              path={DefaultRoutes.extensionRequestDetail}
              element={<ExtensionRequestDetails />}
            />
            <Route
              path={DefaultRoutes.delegateRequestDetail}
              element={<DelegateRequestDetails />}
            />

            <Route
              path={DefaultRoutes.ViewExitPlan}
              element={<ExitPlanPage />}
            />

            {/* Exemption Requests */}
            <Route
              path={DefaultRoutes.regulatoryExemptions}
              element={<RegulatoryExemptionsListing />}
            />
            <Route
              path={DefaultRoutes.exemptionInfo}
              element={<ExemptionRequestPage />}
            />
          </Routes>
        </Box>
      )}

      {user.isLogged && user.role === "R&D" && (
        <Box
          sx={{
            pt: `${theme.navbar.navbarHeight}px`,
            ml: `${theme.sidebar.sidebarWidth}px`,
          }}
        >
          <Routes>
            <Route path="/" element={<RnDMemberHome />} />
            <Route path={DefaultRoutes.home} element={<RnDMemberHome />} />
            <Route
              path={DefaultRoutes.error}
              element={<FallbackPage isErrorPage={true} />}
            />
            <Route path={DefaultRoutes.profile} element={<Profile />} />
            <Route
              path={DefaultRoutes.notifications}
              element={<Notification />}
            />

            {/* R&D Member Routes */}
            {/* Incoming Requests */}
            <Route
              path={DefaultRoutes.rdIncomingRequests}
              element={<IncomingExitRequestsListing />}
            />
            <Route
              path={DefaultRoutes.rdRequestInfoFromIncomingRequests}
              element={<ExitRequestDetailRD />}
            />
            <Route
              path={DefaultRoutes.rdRequestResponseFromIncomingRequests}
              element={<ExitRequestResponseUnified />}
            />
            <Route
              path={DefaultRoutes.reqInfo}
              element={<ExitRequestDetail />}
            />

            {/* Responded Requests */}
            <Route
              path={DefaultRoutes.rdResponses}
              element={<MyResponsesListing />}
            />
            <Route
              path={DefaultRoutes.rdRequestResponseFromResponses}
              element={<ExitRequestResponseUnified />}
            />

            {/* Exit Plans */}
            <Route
              path={DefaultRoutes.rdExitPlans}
              element={<ExitPlansListing />}
            />
            <Route
              path={DefaultRoutes.rdExitPlanInfo}
              element={<ExitPlanDetail />}
            />
            <Route
              path={DefaultRoutes.rdExitPlanEdit}
              element={<ExitPlanPage />}
            />
            <Route
              path={DefaultRoutes.rdExitPlanCreate}
              element={<ExitPlanPage />}
            />

            {/* Exemption Requests */}
            <Route
              path={DefaultRoutes.rdExemptions}
              element={<MyExemptionsListing />}
            />
            <Route
              path={DefaultRoutes.rdExemptionCreate}
              element={<ExitPlanPage initialPlanType="EXEMPTION_REQUEST" />}
            />
            <Route
              path={DefaultRoutes.exemptionInfo}
              element={<ExemptionRequestPage />}
            />
            <Route
              path={DefaultRoutes.activeReqs}
              element={<AllPendingExitRequestsListingFromRD />}
            />
            <Route
              path={DefaultRoutes.ViewExitPlan}
              element={<ExitPlanPage />}
            />
            <Route
              path={DefaultRoutes.reqInfo}
              element={<ExitRequestDetail />}
            />
            <Route
              path={DefaultRoutes.myReqInfo}
              element={<ExitRequestDetail />}
            />
            <Route
              path={DefaultRoutes.rdDelegationRequests}
              element={<RnDDelegationRequests />}
            />
            <Route
              path={DefaultRoutes.rdExtensionRequests}
              element={<ExtensionRequestsListing />}
            />
            <Route
              path={DefaultRoutes.extensionRequestDetail}
              element={<ExtensionRequestDetails />}
            />
            <Route
              path={DefaultRoutes.delegateRequestDetail}
              element={<DelegateRequestDetails />}
            />
          </Routes>
        </Box>
      )}

      {user.isLogged && user.role === "ADMIN" && (
        <Box
          sx={{
            pt: `${theme.navbar.navbarHeight}px`,
            ml: `${theme.sidebar.sidebarWidth}px`,
          }}
        >
          <Routes>
            <Route path="/" element={<AdminHome />} />
            <Route path={DefaultRoutes.home} element={<AdminHome />} />
            <Route path={DefaultRoutes.users} element={<UsersListing />} />
            <Route
              path={DefaultRoutes.categories}
              element={<CategoriesListing />}
            />

            <Route path={DefaultRoutes.profile} element={<Profile />} />
            <Route
              path={DefaultRoutes.notifications}
              element={<Notification />}
            />
            <Route
              path={DefaultRoutes.categories}
              element={<CategoriesListing />}
            />
            <Route path={DefaultRoutes.regions} element={<RegionsListing />} />
          </Routes>
        </Box>
      )}

        {user.isLogged && (user.role === "APPROVER" || user.role === "MANAGER") && (
            <Box
                sx={{
                    pt: `${theme.navbar.navbarHeight}px`,
                    ml: `${theme.sidebar.sidebarWidth}px`,
                }}
            >
                <Routes>
                    <Route path="/" element={<ApproverHome />} />
                    <Route
                        path={DefaultRoutes.home}
                        element={<ApproverHome />}
                    />


                    <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                    />
                    <Route path={DefaultRoutes.profile} element={<Profile />} />
                    <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                    />

                    {/* Approver exit requests routes */}
                    <Route
                        path={DefaultRoutes.AllExitRequests}
                        element={<AllExitRequestsListing />}
                    />
                    <Route
                        path={DefaultRoutes.PendingApprovals}
                        element={<PendingApprovalsListing />}
                        />
                    <Route
                        path={DefaultRoutes.AssignedRequests}
                        element={<AssignedRequestsListing />}
                    />
                    {/* Plans to Approve - hidden: exit plans no longer require approval.
                        Uncomment to restore when needed again.
                    <Route
                        path={DefaultRoutes.ApproverPlansToApprove}
                        element={<PlansPendingApprovalListing />}
                    />
                    */}
                    <Route
                        path={DefaultRoutes.ApproverExemptionsToApprove}
                        element={<ExemptionsPendingApproval />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverExemptionsHub}
                        element={<AllExemptionsListing />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverExemptionCreate}
                        element={<ExitPlanPage initialPlanType="EXEMPTION_REQUEST" />}
                    />
                    <Route
                        path={DefaultRoutes.exemptionInfo}
                        element={<ExemptionRequestPage />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverRequestInfo}
                        element={<ExitRequestDetailApprover />}
                    />

                    {/* Escalated Requests */}
                    <Route
                        path={DefaultRoutes.ApproverEscalatedRequests}
                        element={<EscalatedRequestsListing />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverEscalatedRequestResponse}
                        element={<ExitRequestResponseUnified />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverEscalatedRequestInfo}
                        element={<ExitRequestDetailApprover />}
                    />

                    {/* Approver Exit Plan routes */}
                    <Route
                        path={DefaultRoutes.ApproverExitPlanCreate}
                        element={<ExitPlanPage />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverExitPlanInfo}
                        element={<ExitPlanPage />}
                    />
                    <Route
                        path={DefaultRoutes.ApproverExitPlanEdit}
                        element={<ExitPlanPage />}
                    />

                    <Route
                        path={DefaultRoutes.reqInfo}
                        element={<ExitRequestDetail />}
                    />

                    <Route
                        path={DefaultRoutes.myReqInfo}
                        element={<ExitRequestDetail />}
                    />
                    <Route
                        path={DefaultRoutes.ViewExitPlan}
                        element={<ExitPlanPage />}
                    />
                </Routes>
            </Box>
        )}

        {/* RD-Manager Routes */}
        {user.isLogged && user.role === "RD_MANAGER" && (
            <Box
                sx={{
                    pt: `${theme.navbar.navbarHeight}px`,
                    ml: `${theme.sidebar.sidebarWidth}px`,
                }}
            >
                <Routes>
                    <Route path="/" element={<RDManagerHome />} />
                    <Route path={DefaultRoutes.home} element={<RDManagerHome />} />
                    <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                    />
                    <Route path={DefaultRoutes.profile} element={<Profile />} />
                    <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                    />

                    {/* RD-Manager Incoming Requests (with escalation flag) */}
                    <Route
                        path={DefaultRoutes.rdManagerIncomingRequests}
                        element={<RDManagerIncomingExitRequestsListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerRequestInfoFromIncomingRequests}
                        element={<ExitRequestDetailRD />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerRequestResponseFromIncomingRequests}
                        element={<ExitRequestResponseUnified />}
                    />

                    {/* RD-Manager Responses */}
                    <Route
                        path={DefaultRoutes.rdManagerResponses}
                        element={<MyResponsesListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerRequestResponseFromResponses}
                        element={<ExitRequestResponseUnified />}
                    />

                    {/* RD-Manager Exit Plans */}
                    <Route
                        path={DefaultRoutes.rdManagerExitPlans}
                        element={<ExitPlansListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerExitPlanInfo}
                        element={<ExitPlanDetail />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerExitPlanEdit}
                        element={<ExitPlanPage />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerExitPlanCreate}
                        element={<ExitPlanPage />}
                    />

                    {/* RD-Manager Exemption Requests */}
                    <Route
                        path={DefaultRoutes.rdManagerExemptions}
                        element={<MyExemptionsListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdManagerExemptionCreate}
                        element={<ExitPlanPage initialPlanType="EXEMPTION_REQUEST" />}
                    />
                    <Route
                        path={DefaultRoutes.exemptionInfo}
                        element={<ExemptionRequestPage />}
                    />

                    {/* Requests Hub */}
                    <Route
                        path={DefaultRoutes.activeReqs}
                        element={<AllPendingExitRequestsListingFromRD />}
                    />
                    <Route
                        path={DefaultRoutes.ViewExitPlan}
                        element={<ExitPlanPage />}
                    />
                    <Route
                        path={DefaultRoutes.reqInfo}
                        element={<ExitRequestDetail />}
                    />
                    <Route
                        path={DefaultRoutes.myReqInfo}
                        element={<ExitRequestDetail />}
                    />

                    {/* Delegation */}
                    <Route
                        path={DefaultRoutes.rdManagerDelegationRequests}
                        element={<RnDDelegationRequests />}
                    />
                    <Route
                        path={DefaultRoutes.delegateRequestDetail}
                        element={<DelegateRequestDetails />}
                    />
                </Routes>
            </Box>
        )}

        {/* Support Provider / Marketing / Supply Chain Routes */}
        {user.isLogged && (user.role === "SUPPORT_PROVIDER" || user.role === "MARKETING" || user.role === "SUPPLY_CHAIN") && (
            <Box
                sx={{
                    pt: `${theme.navbar.navbarHeight}px`,
                    ml: `${theme.sidebar.sidebarWidth}px`,
                }}
            >
                <Routes>
                    <Route path="/" element={<SupportProviderHome />} />
                    <Route
                        path={DefaultRoutes.home}
                        element={<SupportProviderHome />}
                    />
                    <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                    />
                    <Route path={DefaultRoutes.profile} element={<Profile />} />
                    <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                    />
                    {/* Support Provider specific routes */}
                    <Route
                        path={DefaultRoutes.supportProviderAssignedRequests}
                        element={<SupportProviderAssignedRequests />}
                    />
                    <Route
                        path={DefaultRoutes.supportProviderAllRequests}
                        element={<SupportProviderAllRequests />}
                    />
                    <Route
                        path={DefaultRoutes.supportProviderRequestsHub}
                        element={<SupportProviderRequestsHub />}
                    />
                    <Route
                        path={DefaultRoutes.supportRequestDetail}
                        element={<SupportRequestDetail />}
                    />
                </Routes>
            </Box>
        )}

        {/* R&D Coordinator Routes */}
        {user.isLogged && user.role === "RD_COORDINATOR" && (
            <Box
                sx={{
                    pt: `${theme.navbar.navbarHeight}px`,
                    ml: `${theme.sidebar.sidebarWidth}px`,
                }}
            >
                <Routes>
                    <Route path="/" element={<RDCoordinatorHome />} />
                    <Route path={DefaultRoutes.home} element={<RDCoordinatorHome />} />
                    <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                    />
                    <Route path={DefaultRoutes.profile} element={<Profile />} />
                    <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                    />

                    {/* Coordinator Incoming Requests */}
                    <Route
                        path={DefaultRoutes.rdCoordinatorIncomingRequests}
                        element={<CoordinatorIncomingRequestsListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdCoordinatorRequestInfo}
                        element={<ExitRequestDetail />}
                    />
                    <Route
                        path={DefaultRoutes.rdCoordinatorResponsePage}
                        element={<CoordinatorResponsePage />}
                    />

                    {/* Coordinator Responses */}
                    <Route
                        path={DefaultRoutes.rdCoordinatorResponses}
                        element={<CoordinatorResponsesListing />}
                    />
                    <Route
                        path={DefaultRoutes.rdCoordinatorResponseFromResponses}
                        element={<CoordinatorResponsePage />}
                    />

                    {/* Shared hub */}
                    <Route
                        path={DefaultRoutes.activeReqs}
                        element={<AllPendingExitRequestsListingFromRD />}
                    />
                    <Route
                        path={DefaultRoutes.reqInfo}
                        element={<ExitRequestDetail />}
                    />
                    <Route
                        path={DefaultRoutes.myReqInfo}
                        element={<ExitRequestDetail />}
                    />
                </Routes>
            </Box>
        )}

      <Routes>
        {!user.isLogged && (
          <>
            <Route path="/" element={<Login />} />
            <Route path={DefaultRoutes.home} element={<Login />} />
            <Route path={DefaultRoutes.fallback} element={<FallbackPage />} />
            <Route
              path={DefaultRoutes.verificationCode}
              element={<VerificationCode />}
            />
            <Route
              path={DefaultRoutes.emailVerification}
              element={<EmailVerifyScreen />}
            />
            <Route
              path={DefaultRoutes.changePassword}
              element={<ChangePasswordScreen />}
            />
          </>
        )}

      </Routes>
    </Router>
  );
}
